import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead,
} from "@/libs/util";
import beforeClose from "@/router/before-close";
import router from "@/router";
import routers from "@/router/routers";
import config from "@/config";

import {
  addBanner,
  bannerList,
  delBanner,
  GetSetting,
  SaveSetting,
  GetDownInformation,
  SaveDownInformation,
  DeleteDownInformation,
  ResetServer,
  GetBanner,
  SaveBanner
} from "@/api/setting";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    addBanner({ commit }, payload) {
      return new Promise(resolve => {
        addBanner(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    bannerList({ commit }, payload) {
      return new Promise(resolve => {
        bannerList(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    delBanner({ commit }, payload) {
      return new Promise(resolve => {
        delBanner(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    GetSetting({ commit }, payload) {
      return new Promise(resolve => {
        GetSetting(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    SaveSetting({commit},payload){
      return new Promise(resolve => {
        SaveSetting(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    GetDownInformation({commit},payload){
      return new Promise(resolve => {
        GetDownInformation(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    SaveDownInformation({commit},payload){
      return new Promise(resolve => {
        SaveDownInformation(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    DeleteDownInformation({commit},payload){
      return new Promise(resolve => {
        DeleteDownInformation(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    ResetServer({commit},payload){
      return new Promise(resolve => {
        ResetServer(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    SaveBanner({commit},payload){
      return new Promise(resolve => {
        SaveBanner(payload).then(res => {
          resolve(res.data);
        });
      });
    },
    GetBanner({commit},payload){
      return new Promise(resolve => {
        GetBanner(payload).then(res => {
          resolve(res.data);
        });
      });
    },
  }
};
